import { z } from "zod";

export const stringFrom = (fallback = "") =>
  z
    .union([z.string(), z.undefined(), z.any()])
    .transform((value) => (typeof value === "string" ? value : fallback));

export const optionalString = z
  .union([z.string(), z.undefined(), z.any()])
  .transform((value) => (typeof value === "string" ? value : undefined));

export const optionalNumber = z
  .union([z.number(), z.undefined(), z.any()])
  .transform((value) =>
    typeof value === "number" && Number.isFinite(value) ? value : undefined,
  );

export const optionalBoolean = z
  .union([z.boolean(), z.undefined(), z.any()])
  .transform((value) => (typeof value === "boolean" ? value : undefined));

const recordSchema = z.record(z.string(), z.unknown()).catch({});

export const messagesArraySchema = z
  .array(z.union([z.string(), z.any()]))
  .catch([])
  .transform((arr): string[] =>
    arr.filter((x): x is string => typeof x === "string"),
  );

export const parseWithRecord = <S extends z.ZodType>(
  item: unknown,
  schema: S,
): z.output<S> => {
  const record = recordSchema.parse(item);
  const parsed: unknown = schema.parse(record);
  // Zod's generic `.parse()` is typed as `any`; runtime output matches `z.output<S>`.

  return parsed as z.output<S>;
};
